const luhnArray = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
const luhn = function (number) {
  var len = number ? number.length : 0,
    bit = 1,
    sum = 0;

  while (len--) {
    sum += !(bit ^= 1) ? parseInt(number[len], 10) : luhnArray[number[len]];
  }

  return sum % 10 === 0 && sum > 0;
};

const validateCreditCard = (inputText) => {
  const tokens = inputText.split(/[^0-9]/);

  const creditCardPieces = [];
  let creditCardNumber = "";
  let expireDate = {};

  for (const token of tokens) {
    if (!isNaN(token) && token.length > 0) {
      if (token.length >= 15 && token.length <= 16 && luhn(token)) {
        creditCardNumber = token;
      } else if (token.length === 2 && token > 0) {
        if (expireDate.month) {
          expireDate.year = token;
        } else {
          expireDate.month = token <= 12 ? token : null;
        }
      } else {
        creditCardPieces.push(token);
      }
    }
  }

  expireDate =
    expireDate.month && expireDate.year
      ? expireDate.month + "/" + expireDate.year
      : null;

  if (creditCardNumber) {
    return {
      expireDate,
      creditCardNumber,
    };
  } else {
    for (let start = 0; start < creditCardPieces.length; start++) {
      let potentialCreditCard = creditCardPieces[start];
      let place = 1;

      do {
        if (potentialCreditCard.length >= 15 && luhn(potentialCreditCard)) {
          return {
            expireDate,
            creditCardNumber: potentialCreditCard,
          };
        } else {
          potentialCreditCard += creditCardPieces[start + place++];
        }
      } while (potentialCreditCard.length <= 16);
    }
  }

  return { expireDate };
};

export { validateCreditCard };
